import React from 'react';
import PropTypes from 'prop-types';

import BWModal from '../BWModal';

const BWFormModal = ({
  submitLabel = 'Lưu thay đổi',
  cancelLabel = 'Đóng',
  onSubmit,
  onClose,
  submitting = false,
  submitDisabled = false,
  dirty = false,
  confirmBeforeClose = true,
  children,
  ...modalProps
}) => (
  <BWModal
    {...modalProps}
    onClose={onClose}
    loading={submitting || modalProps.loading}
    dirty={dirty}
    confirmBeforeClose={confirmBeforeClose}
    cancelAction={{ label: cancelLabel }}
    primaryAction={{
      label: submitLabel,
      onClick: onSubmit,
      loading: submitting,
      disabled: submitDisabled,
    }}>
    {children}
  </BWModal>
);

BWFormModal.propTypes = {
  submitLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
  submitDisabled: PropTypes.bool,
  dirty: PropTypes.bool,
  confirmBeforeClose: PropTypes.bool,
  children: PropTypes.node,
};

export default BWFormModal;
